import { createSlice } from "@reduxjs/toolkit";

export const basketSlice = createSlice({
  name: "basket",
  initialState: {
    basket_count: 0,
  },
  reducers: {
    set_basket_count: (state, action) => {
      state.basket_count = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { set_basket_count } = basketSlice.actions;

export default basketSlice.reducer;
